module.exports = __webpack_public_path__ + "img/stroller.7d5d5e60.svg";